import { BitfODataEnvelopeMapper } from '@bitf/core/parsers/odata-parser/bitf-odata-envelope.mapper';

export class AppEnvelopeMapper extends BitfODataEnvelopeMapper {}
